import { render, staticRenderFns } from "./ClaimInformation.vue?vue&type=template&id=2fde0b0d&"
import script from "./ClaimInformation.vue?vue&type=script&lang=ts&"
export * from "./ClaimInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports